export default "__VITE_ASSET__BqlrFYP6__"